import FinEaseHomeRoutes from "./navigationRoutes";
import FinEaseHomePage from "../pages/FinEaseHomePage/Home";
import FinEaseAdmin from "../pages/FinEaseAdminPage";
import DashboardPage from "../pages/AdminFinEase/Dashboard";
import NpsUserList from "../pages/AdminFinEase/Nps/NpsUserList";
import NpsUserDetails from "../pages/AdminFinEase/Nps/NpsUserDetails";
import ActivityLogsPage from "../pages/AdminFinEase/activity-logs/ActivityLogsPage";
import PaymentManagementPage from "../pages/AdminFinEase/Nps/PaymentManagement/PaymentManagementPage";
// Public routes that don't require authentication
const publicRoutes = [
  {
    path: FinEaseHomeRoutes.FIN_EASE_HOME,
    element: FinEaseHomePage,
    name: "FinEase Home",
  },
  {
    path: FinEaseHomeRoutes.ADMIN,
    element: FinEaseAdmin,
    name: "FinEase Admin",
  },
];

const authRoutes = [
  {
    path: FinEaseHomeRoutes.DASHBOARD,
    element: DashboardPage,
    name: "Dashboard",
  },

  {
    path: FinEaseHomeRoutes.NPS_USER_LIST,
    element: NpsUserList,
    name: "Nps User List",
  },

  {
    path: FinEaseHomeRoutes.NPS_USER_DETAILS_ROUTE,
    element: NpsUserDetails,
    name: "Nps User Details",
  },
  // Activity Log Management
  {
    path: FinEaseHomeRoutes.ACTIVITY_LOG,
    element: ActivityLogsPage,
    name: "Activity Log",
  },

  // Payment Entry Management
  {
    path: FinEaseHomeRoutes.PAYMENT_ENTRY,
    element: PaymentManagementPage,
    name: "Payment Entry",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: authRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
